import React, { useState, useEffect } from "react";
import i18n from "../i18n.js";
import { Link, useLocation } from "react-router-dom";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import Box from "@mui/material/Box";
import LinearProgress from "@mui/material/LinearProgress";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Skeleton from "@mui/material/Skeleton";
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import PersonSearchIcon from "@mui/icons-material/PersonSearch";
import Container from "@mui/material/Container";
import axios from "axios";
import Couple from "./components/WdsfCouple";
import { parse, compareAsc} from "date-fns";

// import { FormContainer, TextFieldElement } from "react-hook-form-mui";

const WdsfCouple = (props) => {
    // eslint-disable-next-line react/prop-types
    const { itemOptions } = props;
    const { api, comp } = itemOptions;
    const { t } = i18n;

    const [loading, setLoading] = useState(false);
    const [person, setPerson] = useState([]);
    const [person2, setPerson2] = useState([]);
    const [couple, setCouple] = useState([]);

    const [email, setEmail] = useState("");
    const [notActive, setNotActive] = useState(false);
    const [notFound, setNotFound] = useState(false);
    const [code, setCode] = useState("");
    let { state } = useLocation();
    useEffect(() => {
        setCode(state.code);
    }, []);
    const {
        handleSubmit,
        control,
        watch,
        formState: { errors, isValid },
    } = useForm({
        defaultValues: {
            min: "",
            min2: "",
            email: "",
        },
    });
    const onSubmit = (data) => {

        if (isValid || Object.entries(errors).length === 0) {
            setLoading(true);

            setNotActive(false);
            setNotFound(false);
            setCouple([]);
            setPerson([]);
            setPerson2([]);
            setEmail(data.email);
            // console.log(data);
            axios
                .get(`${api.getWdsfCoupleByMin}${data.min}/${data.min2}`, data)
                .then(function (response) {
// console.log(response.data)

                    const fetchedCouple = response.data.couple;
                    if (fetchedCouple !== null && fetchedCouple.length>0) {
                        const fetchedPerson = response.data.person;
                        const fetchedPerson2 = response.data.person2;
                        let activeAthlete = false;
                        let activeAthlete2 = false;
                        const compStart = parse(comp.dateStart, "yyyy-LL-dd", new Date());
                        if (fetchedPerson !== null) {
                            fetchedPerson.licenses.forEach((l) => {
                                const expDate = parse(l.expiresOn, "yyyy-LL-dd", new Date());
                                if (l.type === "Athlete" && compareAsc(expDate, compStart) > 0) {
                                    activeAthlete = true;
                                }
                            });
                        }
                        if (fetchedPerson2 !== null) {
                            fetchedPerson2.licenses.forEach((l) => {
                                const expDate = parse(l.expiresOn, "yyyy-LL-dd", new Date());
                                if (l.type === "Athlete" && compareAsc(expDate, compStart) > 0) {
                                    activeAthlete2 = true;
                                }
                            });
                        }
                        if (!(activeAthlete && activeAthlete2)) {
                            setNotActive(true);
                        } else {
                            setCouple(fetchedCouple[0]);
                            setPerson(fetchedPerson);
                            setPerson2(fetchedPerson2);
                        }
                    } else {
                        setNotFound(true);
                    }

                    setLoading(false);
                })
                .catch(function (error) {
                    setLoading(false);

                    console.log(error);
                });
        } else {
            console.log(errors);

        }
    };
    const onError = (errors, e) => {
        console.log(errors);
    };

    const againClick = () => {
        setCouple([]);
        setPerson([]);
        setPerson2([]);
    };
    useEffect(() => {
        setEmail(watch["email"]);
    }, [watch["email"]]);

    return (
        <React.Fragment>
            <hr />
            <h2 className="display-6 mt-2">{t("reg.wdsf.couple")}</h2>
            <p>{t("reg.info.wdsf.couple")}</p>
            {couple?.length === 0 && (
                <Container maxWidth="xs" className="mb-2">
                    <Box>
                        <form onSubmit={handleSubmit(onSubmit, onError)}>
                            <Stack direction="column" spacing={{ xs: 1, sm: 1, md: 4 }}>
                                <Controller
                                    name="email"
                                    control={control}
                                    rules={{
                                        pattern:
                                            /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
                                    }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("email")}
                                            type="email"
                                            required
                                            error={errors.email !== undefined}
                                            helperText={errors.email !== undefined ? t("reg.wdsf.helper.email") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="min"
                                    control={control}
                                    rules={{ pattern: /[1]{1}[0-9]{7}/ }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("man_min")}
                                            type="text"
                                            required
                                            error={errors.min !== undefined}
                                            helperText={errors.min !== undefined ? t("reg.wdsf.helper.min") : ""}
                                        />
                                    )}
                                />
                                <Controller
                                    name="min2"
                                    control={control}
                                    rules={{ pattern: /[1]{1}[0-9]{7}/ }}
                                    render={({ field }) => (
                                        <TextField
                                            {...field}
                                            label={t("woman_min")}
                                            type="text"
                                            required
                                            error={errors.min !== undefined}
                                            helperText={errors.min !== undefined ? t("reg.wdsf.helper.min") : ""}
                                        />
                                    )}
                                />
                                {!loading && (
                                    <Button type="submit" variant="outlined">
                                        {t("reg.wdsf.search")}
                                    </Button>
                                )}
                                {loading && <LinearProgress />}
                            </Stack>
                        </form>
                    </Box>
                </Container>
            )}
            {(loading || couple?.id !== undefined) && (
                <Card variant="outlined">
                    <CardContent>
                        {loading && (
                            <Stack spacing={1}>
                                <Skeleton variant="rectangular" width={210} height={60} />
                                <Skeleton variant="rectangular" width={210} height={60} />
                                <Skeleton variant="rectangular" width={210} height={60} />
                            </Stack>
                        )}
                        {couple?.id !== undefined && (
                            <Stack spacing={1}>
                                <Couple couple={couple} t={t} />
                                <Button variant="contained" color="warning" onClick={againClick} startIcon={<PersonSearchIcon />}>
                                    {t("reg.wdsf.again")}
                                </Button>
                                <Link
                                    to="/categories"
                                    state={{
                                        person1: person,
                                        person2: person2,
                                        couple: couple,
                                        team: null,
                                        email: email,
                                        fromWdsf: true,
                                        fromForm: false,
                                        isSolo: false,
                                        isCouple: true,
                                        isTeam: false,
                                        code:code
                                    }}
                                >
                                    <Button variant="contained" startIcon={<HowToRegIcon />} fullWidth>
                                        {t("reg.wdsf.continue")}
                                    </Button>
                                </Link>
                            </Stack>
                        )}
                        {/* </div> */}
                    </CardContent>
                </Card>
            )}
            {notActive && <Alert severity="error">{t("reg.wdsf.not_active_athlete")}</Alert>}
            {notFound && <Alert severity="warning">{t("reg.wdsf.not_found_athlete")}</Alert>}
        </React.Fragment>
    );
};

export default WdsfCouple;
